// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b36d0dd5","455":"f8c48773","644":"9cd34a77"}[chunkId] + ".chunk.js";
};